"use client";

import { LuUser as LuUser2, LuUsers as LuUsers2 } from "react-icons/lu";

import { setDialog } from "@/components/app/dialogs/dialog-provider";
import { ProfileStat } from "@/components/app/profile/profile-stat";
import { DIALOG } from "@/utils/dialog-routes";
import { pluralize } from "@/utils/helpers";
import { cn } from "@/utils/lib";

import { FollowTab } from "./follow-modal/follow-modal-constants";

export const UserFollowCounts = ({
  followersCount,
  followingCount,
  username = "",
  publicKey,
  className,
  statClassName,
  variant = "inline",
}: {
  publicKey: string;
  username?: string;
  followingCount: number;
  followersCount: number;
  className?: string;
  statClassName?: string;
  variant?: "inline" | "responsiveStacked" | "stacked";
}) => {
  const followModals = [
    {
      key: "followers",
      icon: <LuUsers2 className="size-5" />,
      count: followersCount,
      label: pluralize(followersCount, "Follower", { includeCount: false }),
      initialTab: FollowTab.followers,
    },
    {
      key: "following",
      icon: <LuUser2 className="size-4" />,
      count: followingCount,
      label: "Following",
      initialTab: FollowTab.following,
    },
  ];

  return (
    <div
      className={cn(
        "flex items-center gap-4",
        (variant === "stacked" || variant === "responsiveStacked") &&
          "items-start",
        variant === "responsiveStacked" && "sm:items-center",
        className,
      )}
    >
      {followModals.map(({ key, icon, count, label, initialTab }) => (
        <button
          key={key}
          type="button"
          className={cn(
            "text-left",
            (variant === "stacked" || variant === "responsiveStacked") &&
              "min-w-0",
          )}
          onClick={() =>
            setDialog(DIALOG.Follow, {
              open: true,
              params: {
                publicKey,
                tab: initialTab,
                username,
              },
            })
          }
        >
          <ProfileStat
            count={count}
            label={label}
            icon={icon}
            className={statClassName}
            variant={variant}
          />
        </button>
      ))}
    </div>
  );
};
